export default {
  orders: (state) => state.orders,
  order: (state) => (id) => state.orders.filter((order) => order.id == id)[0],
  newOrder: (state) => state.newOrder,
  product: (state) => state.product,
  guestOrder: (state) => state.guestOrder,
  fibToken: (state) => state.fibToken,
};
